export const APP_API_ENCRYPTION_KEY = "Z21`,nS4&y{lBY2o7IqFy]_,iHeR]qo5z@GFF:-jYwAYY6IgHZqqAGK`]K?B*"
export const POSTHOG_KEY = "hc_FJw7XaEHnmYYiO0MhVpofhrqGPVkxFJMhAq7hdlhEZe"
export const FIREBASE_KEY = "AIzaSyDoKSwRedsNR7e7FB-4yleNJCctC9J9-IM"